import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconUserGroup } from '../../../base/icons/svg';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import { getVisitorsShortText, shouldHideVisitorsCount } from '../../functions';
const useStyles = makeStyles()(theme => {
    return {
        label: {
            alignItems: 'center',
            backgroundColor: theme.palette.ui03,
            borderRadius: '6px',
            color: theme.palette.text01,
            cursor: 'default',
            display: 'flex',
            fontSize: '13px',
            fontWeight: 600,
            gap: '6px',
            lineHeight: '20px',
            margin: '0 4px',
            padding: '4px 10px'
        },
        icon: {
            alignItems: 'center',
            display: 'flex'
        }
    };
});
/**
 * A header label showing how many visitors (viewers) have joined the meeting, styled like the
 * participant-count pill. Only shown to non-visitors when there is at least one visitor.
 *
 * @returns {JSX.Element | null}
 */
const VisitorsCountLabel = () => {
    const { classes, theme } = useStyles();
    const hideVisitorsCount = useSelector((state) => shouldHideVisitorsCount(state));
    const visitorsCount = useSelector((state) => state['features/visitors'].count || 0);
    const { t } = useTranslation();
    if (hideVisitorsCount || visitorsCount <= 0) {
        return null;
    }
    return (React.createElement(Tooltip, { content: t('visitors.labelTooltip', { count: visitorsCount }), position: 'bottom' },
        React.createElement("div", { className: classes.label, id: 'visitorsCountLabel' },
            React.createElement(Icon, { className: classes.icon, color: theme.palette.text01, size: 16, src: IconUserGroup }),
            React.createElement("span", null, getVisitorsShortText(visitorsCount)))));
};
export default VisitorsCountLabel;
